
<style scoped>
    @import "./speedOfProgress.css";
</style>

<template>
    <div id="speedOfProgress">

        <div class="list">
            <div class="listIn" v-for="(item) in listData" v-bind:key="item.id">
                <div class="progressTopView">
                    <span>ID:{{item.id}}</span>
                    <span style="margin-left:auto;" :class=" item.schedule == 0 ? '' : item.schedule == 1 ? 'textColor1' : item.schedule == 2 ? 'textColor2' : item.schedule == 3 ? 'textColor3' : 'textColor4'">{{item.progress}}</span>
                </div>
                <div class="progressMainView">
                    <img :src="item.schedule >= 1 ? icon_one : icon_one1" alt="" class="imageC">
                    <div class="lineC" :style="(item.schedule > 1) || (item.schedule == 1 && item.status != 1) ? 'background:#467fff;' : ''"><span v-if="item.status == 2" class="redX">x</span></div>

                    <img :src="item.schedule >= 2 ? icon_two : icon_two1" alt="" class="imageC">
                    <div class="lineC" :style="(item.schedule > 2) || (item.schedule == 2 && item.status != 1) ? 'background:#5ec95a;' : ''"></div>
                    <img :src="item.schedule >= 3 ? icon_three : icon_three1" alt="" class="imageC">
                    <div class="lineC" :style="(item.schedule > 3) || (item.schedule == 3 && item.status != 1) ? 'background:#f7d429;' : ''"></div>
                    <img :src="item.schedule >= 4 ? icon_four : icon_four1" alt="" class="imageC">
                </div>
            </div>
        </div>
        <div class="bottom">
            <a-pagination v-model="pageNum" :total="total" :pageSize="pageSize" @change="pageChange"/>
        </div>
    </div>
</template>
<script>

    import icon_one from '../../image/icon_one.png';
    import icon_one1 from '../../image/icon_one1.png';

    import icon_two from '../../image/icon_two.png';
    import icon_two1 from '../../image/icon_two1.png';

    import icon_three from '../../image/icon_three.png';
    import icon_three1 from '../../image/icon_three1.png';

    import icon_four from '../../image/icon_four.png';
    import icon_four1 from '../../image/icon_four1.png';

    import https from '@/plugins/http.js';
    import apiUrl from '@/assets/api.js';
    import App from '@/assets/app.js';

    export default {
        name: 'speedOfProgress',
        data(){
            return{
                icon_one,
                icon_one1,
                icon_two,
                icon_two1,
                icon_three,
                icon_three1,
                icon_four,
                icon_four1,
                
                listData : [],
                pageNum:1,
                total:0,
                pageSize:4
            }
        },
        created(){
            this.messLoad();
        },
        methods:{
            messLoad(){
                let _this = this;
                let json = {
                    token : _this.$store.state.token,
                }
                https.fetchPost(apiUrl.getProgress,{
                    perPage : _this.pageSize,
                    pageNum : _this.pageNum,
                },json).then((data) => {
                    if(Object.is(data.qmiscode,1000)){
                        _this.total = data.total;
                        _this.listData = data.progress;
                    }else{
                        App.oTool.warningT(data.qmismsg);
                    }
                }).catch(err => {
                    console.log(err);
                });
            },
            pageChange(page, pageSize){
                console.log(page, pageSize);
                this.pageNum = page;
                this.messLoad();
            }
        },
    }
</script>